import { render } from "./NotificationsModal.vue?vue&type=template&id=a4bbe520&scoped=true"
import script from "./NotificationsModal.vue?vue&type=script&lang=js"
export * from "./NotificationsModal.vue?vue&type=script&lang=js"

import "./NotificationsModal.vue?vue&type=style&index=0&id=a4bbe520&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a4bbe520"]])

export default __exports__